import type { EnrollmentChoices } from 'bundles/enroll-common/components/xdp/withEnrollment';
import googleCertificateExperiments from 'bundles/epic/clients/GoogleCertificate';
import type CourseTypeMetadataV1 from 'bundles/naptimejs/resources/courseTypeMetadata.v1';
import { CourseType } from 'bundles/naptimejs/resources/courseTypeMetadata.v1';

// Record impression for US pricing test: https://tools.coursera.org/epic/experiment/hK-OSaLqEfCAfhJYNo68EQ
export const generateImpressionForUsPricingTest = () => googleCertificateExperiments.get('coursePriceIncreaseTo72');

export const isUsPricingTestEnabled = () => googleCertificateExperiments.preview('coursePriceIncreaseTo72') === 'test';

// Hard-coding price string since this is a US-only pricing test that standardizes C+ pricing to $49
export const courseraPlusPriceInUsTest = '$49';

export const isEligibleCourseForUsPricingTest = ({
  isSpecialization,
  courseTypeMetadataWithVersion,
  enrollmentAvailableChoices,
}: {
  isSpecialization?: boolean;
  courseTypeMetadataWithVersion?: CourseTypeMetadataV1;
  enrollmentAvailableChoices?: EnrollmentChoices;
}) => {
  // Only standalone courses that are purchaseable by the learner are eligible
  // (not course-in-s12n or Projects/Guided Projects, and not if the learner can't purchase and thus see the price)
  return (
    !isSpecialization &&
    courseTypeMetadataWithVersion?.courseTypeMetadata.typeName === CourseType.STANDARD_COURSE &&
    enrollmentAvailableChoices?.canPurchaseSingleCourse
  );
};
